export const prerender = true;
const PROD_URL = 'https://davidoff-immo.up.railway.app';
/** @type {import('./$types').PageLoad} */
export async function load({ fetch }) {
	try {
		const res = await fetch(PROD_URL + '/api/referenzens?populate=*').then((res) => res.json());
		const bg = await fetch(PROD_URL + '/api/universal-background?populate=*').then((bg) =>
			bg.json()
		);
		return {
			res,
			bg
		};
	} catch (err) {
		console.log(err);
	}
}
